<template>
  <div class="container">
    <div class="row pt-32">
      <table class="table mr-35 ml-35">
        <thead>
          <tr class="activity-status-border">
            <th class="activity-status-name pt-7 pb-7">Approval Status</th>
            <th class="activity-status-name pt-7 pb-7">Verification Status</th>
            <th class="activity-status-name pt-7 pb-7">Signed Off Status</th>
            <th class="activity-status-name pt-7 pb-7">Review Status</th>
            <th class="activity-status-name pt-7 pb-7">Locked Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!loading" class="milestone-row-bg">
            <td>
              <template v-if="isSiteTeamMember() && !user.readOnly && !isLocked && approvedStatusEnabled">
                <a href="#" @click.prevent="toggleMilestoneApprovalModal()">{{ approvedStatusText }}</a>
              </template>
              <template v-else>{{ approvedStatusText }}</template>
            </td>
            <td>
              <template v-if="(canCraAccess || canCraUBAccess) && !isLocked && verifiedStatusEnabled">
                <a href="#" @click.prevent="toggleVerifyModal()">{{ verifiedStatusText }}</a>
              </template>
              <template v-else>{{ verifiedStatusText }}</template>
            </td>
            <td>
              <template v-if="canPiAccess && isVerified && isApproved && !isLocked && signedOffStatusEnabled">
                <a href="#" @click.prevent="toggleMilestoneSignedOff()">{{ signedOffStatusText }}</a>
              </template>
              <template v-else>{{ signedOffStatusText }}</template>
            </td>
            <td>
              <template v-if="(canCraAccess || canDmAccess || canCraUBAccess) && !isLocked && reviewedStatusEnabled">
                <a href="#" @click.prevent="toggleMilestoneReviewModal()">{{ reviewedStatusText }}</a>
              </template>
              <template v-else>{{ reviewedStatusText }}</template>
            </td>
            <td>
              <template v-if="(canCraAccess || canDmAccess || canCraUBAccess) && lockedStatusEnabled && !disableActvityLockUnlockBtn">
                <a href="#" @click.prevent="toggleLockedModal()">{{ lockedStatusText }}</a>
              </template>
              <template v-else>{{ lockedStatusText }}</template>
            </td>
          </tr>
          <tr v-else class="milestone-row-bg">
            <td colspan="5" class="text-center">Loading statuses...</td>
          </tr>
        </tbody>
      </table>
      <user-confirmation-modal ref="userConfirmationModal" />
      <user-verification-modal ref="userVerificationModal" :userDetails="userDetails" />
    </div>
  </div>
</template>

<script>
import UserAccesses from "@/mixins/user-accesses";
import ParticipantFormStatus from "@/mixins/participant-form-status";
import UserConfirmationModal from "@/components/modals/user-confirmation-modal";
import UserVerificationModal from "@/components/modals/user-verification-modal";
export default {
  name: "milestoneAction",
  mixins: [UserAccesses, ParticipantFormStatus],
  props: ["selectedMilestone", "studyId", "participantId", "studyData", "userDetails"],
  data() {
    return {
      disableActvityLockUnlockBtn: false,
    };
  },
  components: {
    UserConfirmationModal,
    UserVerificationModal
  },
  watch: {
    selectedMilestone: {
      handler() {
        this.milestone = this.selectedMilestone;
        this.getMilstoneLevelStatus();
      }
    }
  },
  methods: {
    getMilstoneLevelStatus() {
      this.milestone = this.selectedMilestone;
      let { milestoneDay } = this.selectedMilestone;
      if (this.studyData.screeningMilestoneAllowed) {
        milestoneDay = milestoneDay + this.studyData.screeningDuration;
      }
      this.selectedMilestoneId = this.selectedMilestone.milestoneId;
      const data = { milestone: milestoneDay };
      this.getFormStatuses(this.studyId, this.participantId, data);
    },
    toggleMilestoneReviewModal() {
      let title, desc, submitBtnText, cancelBtnText, yesBtnText, noBtnText;
      let data;
      if (this.studyData.screeningMilestoneAllowed) {
        data = {
          milestone: this.selectedMilestone.milestoneDay + this.studyData.screeningDuration
        };
      } else {
        data = { milestone: this.selectedMilestone.milestoneDay };
      }
      if (!this.isReviewed) {
        title = `Review ${this.selectedMilestone.milestoneName}`;
        desc = `I hereby confirm the completeness and correctness of all data entered within this document by applying an electronic signature,
                using my account username and password. This electronic signature is the legally binding equivalent of my handwritten signature.
                I understand that this electronic signature is assigned only to my account username and password;
                no other person is authorized to use my account information.<br /><br />Please enter your username and password to sign this document.`;
        submitBtnText = "Yes, review";
        cancelBtnText = "No, do not review";

        this.$refs.userVerificationModal.open(title, desc, submitBtnText, cancelBtnText).then(() => {
          this.updateReviewStatus(!this.isReviewed, this.studyId, this.participantId, data, this.userDetails);
        });
      } else {
        title = "Are you sure you want to rescind the review for this milestone?";
        yesBtnText = 'Yes, change to "Unreviewed" status';
        noBtnText = 'No, do not change to "Unreviewed" status';

        this.$refs.userConfirmationModal.open(title, yesBtnText, noBtnText).then(() => {
          this.updateReviewStatus(!this.isReviewed, this.studyId, this.participantId, data, this.userDetails);
        });
      }
    },
    toggleMilestoneApprovalModal() {
      let title, desc, submitBtnText, cancelBtnText, yesBtnText, noBtnText;
      let data;
      if (this.studyData.screeningMilestoneAllowed) {
        data = {
          milestone: this.selectedMilestone.milestoneDay + this.studyData.screeningDuration
        };
      } else {
        data = { milestone: this.selectedMilestone.milestoneDay };
      }
      if (!this.isApproved) {
        title = `Approve ${this.selectedMilestone.milestoneName}`;
        desc = `Herewith I confirm the completeness and correctness of the data by applying an electronic signature,
                using my account name and password. This electronic signature is the legally binding equivalent of my handwritten signature.
                I understand that this electronic signature is assigned only to my account name and password;
                no other person is authorized to use these.<br /><br />Please enter your username and password to approve.`;
        submitBtnText = "Yes, approve";
        cancelBtnText = "No, do not approve";

        this.$refs.userVerificationModal.open(title, desc, submitBtnText, cancelBtnText).then(() => {
          this.updateApprovalStatus(!this.isApproved, this.studyId, this.participantId, data, this.userDetails);
        });
      } else {
        title = "Are you sure you want to rescind approval for this milestone?";
        yesBtnText = "Yes, unapprove";
        noBtnText = "No, do not unapprove";

        this.$refs.userConfirmationModal.open(title, yesBtnText, noBtnText).then(() => {
          this.updateApprovalStatus(!this.isApproved, this.studyId, this.participantId, data, this.userDetails);
        });
      }
    },
    toggleVerifyModal() {
      let title, yesBtnText, noBtnText;
      let data;
      if (this.studyData.screeningMilestoneAllowed) {
        data = {
          milestone: this.selectedMilestone.milestoneDay + this.studyData.screeningDuration
        };
      } else {
        data = { milestone: this.selectedMilestone.milestoneDay };
      }
      if (!this.isVerified) {
        title = "Have you thoroughly verified this milestone?";
        yesBtnText = 'Yes, change to "verified" status';
        noBtnText = 'No, do not change to "verified" status';
      } else {
        title = "Are you sure you want to rescind verification for this milestone?";
        yesBtnText = 'Yes, change to "unverified" status';
        noBtnText = 'No, do not change to "unverified" status';
      }
      this.$refs.userConfirmationModal.open(title, yesBtnText, noBtnText).then(() => {
        this.updateVerifyStatus(!this.isVerified, this.studyId, this.participantId, data, this.userDetails);
      });
    },
    toggleLockedModal() {
      if (this.disableActvityLockUnlockBtn) {
        return;
      }
      let title, yesBtnText, noBtnText;
      let data;
      if (this.studyData.screeningMilestoneAllowed) {
        data = {
          milestone: this.selectedMilestone.milestoneDay + this.studyData.screeningDuration
        };
      } else {
        data = { milestone: this.selectedMilestone.milestoneDay };
      }

      if (!this.isLocked) {
        title = "Do you wish to lock this milestone?";
        yesBtnText = 'Yes, change to "locked" status';
        noBtnText = 'No, do not change to "locked" status';
      } else {
        title = "Are you sure you want to unlock this milestone?";
        yesBtnText = 'Yes, change to "unlocked" status';
        noBtnText = 'No, do not change to "unlocked" status';
      }
      this.$refs.userConfirmationModal.open(title, yesBtnText, noBtnText).then(() => {
        this.updateLockStatus(!this.isLocked, this.studyId, this.participantId, data, this.userDetails);
      });
    },
    toggleMilestoneSignedOff() {
      let title, desc, submitBtnText, cancelBtnText;
      let data;
      if (this.studyData.screeningMilestoneAllowed) {
        data = {
          milestone: this.selectedMilestone.milestoneDay + this.studyData.screeningDuration
        };
      } else {
        data = { milestone: this.selectedMilestone.milestoneDay };
      }

      if (!this.isSignedOff) {
        title = `Signed Off ${this.selectedMilestone.milestoneName}`;
        desc = `Herewith I confirm the completeness and correctness of all data entered into the THREAD Platform by applying an electronic signature,
                using my account name and password. This electronic signature is the legally binding equivalent of my handwritten signature.
                I understand that this electronic signature is assigned only to my account name and password;
                no other person is authorized to use these.<br /><br />Please enter username and password to sign this document.`;
        submitBtnText = "Yes, Signed Off";
        cancelBtnText = "No, do not Signed Off";

        this.$refs.userVerificationModal.open(title, desc, submitBtnText, cancelBtnText).then(() => {
          this.updateSignedOffStatus(!this.isSignedOff, this.studyId, this.participantId, data, this.userDetails);
        });
      } else {
        title = `Unsigned Off ${this.selectedMilestone.milestoneName}`;
        desc = `Herewith I confirm the completeness and correctness of all data entered into the THREAD Platform by applying an electronic signature,
                using my account name and password. This electronic signature is the legally binding equivalent of my handwritten signature.
                I understand that this electronic signature is assigned only to my account name and password;
                no other person is authorized to use these.<br /><br />Please enter username and password to sign this document.`;
        submitBtnText = "Yes, Unsigned Off";
        cancelBtnText = "No, do not Unsigned Off";

        this.$refs.userVerificationModal.open(title, desc, submitBtnText, cancelBtnText).then(() => {
          this.updateSignedOffStatus(!this.isSignedOff, this.studyId, this.participantId, data, this.userDetails);
        });
      }
    },

    isSiteTeamMember() {
      return this.canHomeHealthAccess || this.canPiAccess || this.canStudyCoordinatorAccess || this.canSubPIAccess || this.canSiteDataLockAccess || this.canCallCenterAccess;
    },
    disableActvityLockUnlockStatus() {
      let dataString = localStorage.getItem("thread-userObj");
      let userDetails = JSON.parse(dataString);
      if (userDetails.restrictions && (userDetails.restrictions.includes("activity_response.lock") || userDetails.restrictions.includes("activity_response.unlock"))) {
        this.disableActvityLockUnlockBtn = true;
      } else {
        this.disableActvityLockUnlockBtn = false;
      }
    }
  },
  mounted() {
    // Get all Status at milestone level
    this.getMilstoneLevelStatus();
    this.disableActvityLockUnlockStatus();
  }
};
</script>

<style lang="scss">
tbody .milestone-row-bg {
  width: 58px;
  height: 16px;
  flex-grow: 0;
  margin: 23px 19px 0 0;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #a4a4a4;
  background-color: #ffffff;
}
.activity-status-name {
  width: 86px;
  height: 16px;
  flex-grow: 0;
  margin: 0 72px 0 0;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #9b9b9b;
}
.activity-status-border {
  border: solid 1px #e4e8eb;
  background-color: #f9f9fb;
}
@media (min-width: 768px) and (max-width: 991px) {
  .has-sidemenu .container {
    width: 750px;
  }
}
</style>
